import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('MeasureUnits')
export class MeasureUnits {
  @JsonProperty('mass', [String], true) mass: string[] = [];
  @JsonProperty('length', [String], true) length: string[] = [];
}
